import React from 'react';
import { useBreakpoint } from '../useBreakpoint';
import DesktopShell, { LayoutWidth } from '../layout/DesktopShell';
import { Crumb } from '../layout/Breadcrumbs';
import MobileShell from './MobileShell';

interface LayoutProps {
  children: React.ReactNode;
  // Desktop only (see DesktopShell): unconverted pages stay in the 720px column
  width?: LayoutWidth;
  breadcrumbs?: Crumb[];
}

const Layout = ({ children, width = 'legacy', breadcrumbs }: LayoutProps) => {
  const { isDesktop } = useBreakpoint();

  if (isDesktop) return <DesktopShell width={width} breadcrumbs={breadcrumbs}>{children}</DesktopShell>;

  return <MobileShell>{children}</MobileShell>;
};

export default Layout;
